import Vue from "vue";
import Vuex from "vuex";
import auth from "../auth.module";
import users from "./users/users.module";
import roles from "./roles/roles.module";
import permissions from "./permissions/permissions.module";
import widget from "./widgets/widgets.module";
import rubrica from "./rubrica/rubrica.module";
import emailVirtuali from "./emailVirtuali/emailVirtuali.module";
import clients from "./clients/clients.module";
import accountPec from "./accountPec/accountPec.module";
import mailbox from "./mailbox/mailbox.module";
import rules from "./rules/rules.module";
import deleghe from "./deleghe/deleghe.module";
import ricercaOperazioni from "./ricercaOperazioni/ricercaOperazioni.module";
import listini from "./listini/listini.module";
import listiniBase from "./listiniBase/listiniBase.module";
import servizi from "./servizi/servizi.module";
import straordinaryOperations from "./straordinaryOperations/straordinaryOperations.module";
import conservazione from "./conservazione/conservazione.module";
import inviaMassive from "./inviaMassive/inviaMassive.module";
import elencoInvii from "./elencoInvii/elencoInvii.module";
import notifications from "./notifications/notifications.module";
import pstImport from "./pstImport/pstImport.module";
import apiKeys from "./apiKeys/apiKeys.module";
import mieiServizi from "./mieiServizi/mieiServizi.module";
import fatturazione from "./fatturazione/fatturazione.module";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
        users,
        roles,
        permissions,
        widget,
        rubrica,
        emailVirtuali,
        clients,
        accountPec,
        mailbox,
        rules,
        deleghe,
        ricercaOperazioni,
        listini,
        listiniBase,
        servizi,
        straordinaryOperations,
        conservazione,
        inviaMassive,
        elencoInvii,
        notifications,
        pstImport,
        apiKeys,
        mieiServizi,
        fatturazione,
    },
});
